import React, { FC, useEffect } from 'react';

import { useSpace } from '@ably/spaces/react';

import { Team, User } from 'models';
import { AblyHelpers } from 'helpers/AblyHelpers';

import { ImpersonationService } from 'services/ImpersonationService';

import { RealtimeTeamProvider } from './RealtimeTeamProvider';

const RealtimeTeamConnector: FC<{ team: Team; user: User }> = ({ team, user }) => (
    <RealtimeTeamProvider team={team}>
        <Connector user={user} />
    </RealtimeTeamProvider>
);

const Connector: FC<{
    user: User;
}> = ({ user }) => {
    const { space, channelError, connectionError } = useSpace();
    const enterable = AblyHelpers.enterable(space);

    AblyHelpers.log('Team', channelError, connectionError);

    useEffect(() => {
        if (space && enterable && !ImpersonationService.isImpersonating()) {
            space.enter(user).catch((error) => {
                console.warn({
                    message: 'Error entering team space',
                    error,
                });
            });
        }
    }, [space, enterable, user.id]);

    return null;
};

export { RealtimeTeamConnector };
